export default "__VITE_ASSET__D$PT2rF1__"